import React from "react";

interface HitasoftLogoProps {
  className?: string;
  lightMode?: boolean;
}

export default function HitasoftLogo({ className = "", lightMode = true }: HitasoftLogoProps) {
  return (
    <div className={`flex items-center select-none ${className}`} id="hitasoft-header-logo">
      <img 
        src="/hitasoft_logo.webp"
        alt="Hitasoft Logo" 
        className="h-12 sm:h-14 w-auto object-contain"
        fetchpriority="high"
        width="498"
        height="153"
      />
    </div>
  );
}

